import { z } from 'zod';

import { EntityId } from '../primitives';
import { AuditEntryDTO } from './audit';

export const TopSongDTO = z.object({
  songId: EntityId,
  title: z.string(),
  artistNames: z.string(),
  plays: z.number().int().nonnegative(),
});
export type TopSongDTO = z.infer<typeof TopSongDTO>;

/** `GET /cms/stats/overview` (docs/06 §2.2) */
export const CmsStatsOverviewResponse = z.object({
  songsPlayed: z.object({
    today: z.number().int().nonnegative(),
    d7: z.number().int().nonnegative(),
    d30: z.number().int().nonnegative(),
  }),
  activeSessions: z.number().int().nonnegative(),
  topSongs: z.array(TopSongDTO).max(10),
  recentAudit: z.array(AuditEntryDTO).max(20),
});
export type CmsStatsOverviewResponse = z.infer<typeof CmsStatsOverviewResponse>;
